module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-body"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "md": 8
    }
  }, [_c('h1', {
    staticClass: "pageTitle"
  }, [_c('i', {
    staticClass: "fa fa-list-alt",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.stock.view.title')))])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('br'), _c('br')]) : _c('div', {
    staticClass: "whiteWrapper"
  }, [_c('el-tabs', {
    model: {
      value: (_vm.tabIndex),
      callback: function($$v) {
        _vm.tabIndex = $$v
      },
      expression: "tabIndex"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.stock.view.details'),
      "name": "first"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.stock.view.detailsLegend')))]), _vm._v(" "), [_c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-sticky-note",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.stock.info.code')) + ":\n                  ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_vm._v("\n                    " + _vm._s(_vm.currentStock.code) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-sticky-note",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.stock.info.warehouse')) + ":\n                  ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_vm._v("\n                    " + _vm._s(_vm.currentStock.warehouse.name) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-sticky-note",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.stock.info.qty')) + ":\n                  ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_vm._v("\n                    " + _vm._s(_vm.currentStock.total_qty) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-sticky-note",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.stock.info.createdAt')) + ":\n                  ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_vm._v("\n                    " + _vm._s(_vm.currentStock.createdAt) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-sticky-note",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.stock.info.transactionDate')) + ":\n                  ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_vm._v("\n                    " + _vm._s(_vm.currentStock.transactionDate) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-sticky-note",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.stock.info.status')) + ":\n                  ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_vm._v("\n                    " + _vm._s(_vm.currentStock.status) + "\n                  ")])])]], 2)])], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.stock.view.products'),
      "name": "products"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24
    }
  }, [_c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.stock.view.productsLegend')))]), _vm._v(" "), _c('v-table', {
    attrs: {
      "list": _vm.productList,
      "noDataMessage": _vm.$t('static.stock.noData'),
      "translation": "static.stock.products"
    }
  })], 1)])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-280541c1","hasScoped":false}!./src/app/pages/withNavigation/stock/view/view.html
// module id = 2947
// module chunks = 1